var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    fill: "#0f6af9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,18c-0.552,0-1-0.448-1-1V3c0-0.552,0.448-1,1-1h14c0.552,0,1,0.448,1,1s-0.448,1-1,1H4v13C4,17.552,3.552,18,3,18z    M46,17V3c0-0.552-0.448-1-1-1H31c-0.552,0-1,0.448-1,1s0.448,1,1,1h13v13c0,0.552,0.448,1,1,1S46,17.552,46,17z M46,45V31   c0-0.552-0.448-1-1-1s-1,0.448-1,1v13H31c-0.552,0-1,0.448-1,1s0.448,1,1,1h14C45.552,46,46,45.552,46,45z M18,45   c0-0.552-0.448-1-1-1H4V31c0-0.552-0.448-1-1-1s-1,0.448-1,1v14c0,0.552,0.448,1,1,1h14C17.552,46,18,45.552,18,45z M24,15   c-4.962,0-9,4.038-9,9s4.038,9,9,9s9-4.038,9-9S28.962,15,24,15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordStop);
export default __webpack_public_path__ + "static/media/record_stop.779d6cf54e64fdc703533d85e8719da0.svg";
export { ForwardRef as ReactComponent };